// The tag list (TAGS.md §1): synced as one row, newest updated_at wins; the bundled default until a row exists.
import { DEFAULT_TAXONOMY, type Taxonomy } from "./tags";
import { Hub } from "../util";

const KEY = "depth.state.taxonomy";

class TaxonomyStore {
  list: Taxonomy = DEFAULT_TAXONOMY;
  updatedAt = 0;
  readonly events = new Hub<{ changed: void }>();
  constructor() {
    try {
      const s = JSON.parse(localStorage.getItem(KEY) || "null");
      if (s?.json) { this.list = JSON.parse(s.json); this.updatedAt = s.updatedAt; }
    } catch { /* default */ }
  }
  applyRemote(json: string, updatedAt: number) {
    if (updatedAt <= this.updatedAt) return;
    try { this.list = JSON.parse(json); } catch { return; }
    this.updatedAt = updatedAt;
    try { localStorage.setItem(KEY, JSON.stringify({ json, updatedAt })); } catch { /* ignore */ }
    this.events.emit("changed", undefined);
  }
}

export const taxonomy = new TaxonomyStore();
